import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "relative" }
const _hoisted_2 = {
  key: 0,
  class: "font-inter text-sm text-red-500 font-normal mt-2"
}

import { onMounted, ref, watch, PropType } from "vue";
import { IOption } from "@/interfaces/SupportInterfaces";
import { ITooltip } from "@/interfaces/CommonInterfaces";
import Tooltip from "./Tooltip.vue";

// Props

export default /*@__PURE__*/_defineComponent({
  __name: 'SelectMenu',
  props: {
  id: {
    type: String,
    default: "snap-select-menu",
  },
  placeholder: {
    type: String,
    default: "Select An Option",
  },
  helpText: {
    type: String,
    default: "",
  },
  label: {
    type: String,
    default: "",
  },
  modalTitle: {
    type: String,
    default: "Select An Option",
  },
  isSearchable: {
    type: Boolean,
    default: false,
  },
  modalType: {
    type: String,
    default: "drawer",
  },
  options: {
    type: Object as PropType<IOption[]>,
    default: null,
  },
  avatar: {
    type: String,
    default: "",
  },
  errorMessage: {
    type: String,
    default: "",
  },
  tooltip: {
    type: Object as PropType<ITooltip>,
    default: null,
  },
  tooltipPosition: {
    type: String,
    default: "right-0",
  },
},
  emits: ["onSelect"],
  setup(__props, { emit: __emit }) {

// Imports
const props = __props;

// Emits
const emit = __emit;

// States
const menuOptions = ref<IOption[]>([]);

const setMenuOptions = () => {
  setTimeout(() => {
    if (props.options?.length) {
      menuOptions.value = [...props.options.map((option) => option)];
    }
  }, 500);
};
onMounted(() => setMenuOptions());
watch(
  () => ({ options: props.options }),
  () => setMenuOptions()
);
const selectOption = (ev: { detail: IOption[] }) => {
  emit("onSelect", ev.detail);
};

return (_ctx: any,_cache: any) => {
  const _component_snap_select_menu = _resolveComponent("snap-select-menu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.tooltip)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(`${__props.tooltipPosition} absolute top-1 z-10`)
        }, [
          _createVNode(Tooltip, {
            heading: __props.tooltip.heading,
            text: __props.tooltip.text
          }, null, 8, ["heading", "text"])
        ], 2))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      _createVNode(_component_snap_select_menu, {
        id: __props.id,
        placeholder: __props.placeholder,
        "help-text": __props.helpText,
        label: __props.label,
        multi: false,
        "modal-type": __props.modalType,
        search: __props.isSearchable,
        "modal-title": __props.modalTitle,
        selectMenuOptions: menuOptions.value,
        error: __props.errorMessage.length,
        "search-method": "contain",
        onSnapSelectMenuUpdated: _cache[0] || (_cache[0] = ($event: any) => (selectOption($event)))
      }, null, 8, ["id", "placeholder", "help-text", "label", "modal-type", "search", "modal-title", "selectMenuOptions", "error"]),
      (__props.errorMessage.length)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(__props.errorMessage), 1))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})